module.exports = __webpack_public_path__ + "img/calculator.ca4899af.svg";